/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ClassificationGroupType {
    COMPLETED_DOCUMENTS = 'COMPLETED_DOCUMENTS',
    UNCLASSIFIED = 'UNCLASSIFIED',
}
